<template>
  <div class="impressum-page">
    <h1 class="bold-font impressum-title">Impressum</h1>

    <div class="row">
      <div class="column">
        <div class="impressum-info-main column">
          <span class="row">Ignite GmbH</span>
          <span class="row">Ernst-Heckel-Straße 6A </span>
          <span class="row">66386 St. Ingbert </span>
          <span class="row">Deutschland </span>
          <span class="row"> E-Mail: info@ignite-group.de</span>
          <span class="row">Tel.: +49 6894 999 56 – 0 </span>
          <span class="row">Fax: +49 32 221739475 </span>
        </div>
        <div class="impressum-info-main column" style="margin-top: 24px">
          <span class="row impressum-subheading bold-font">
            Angaben für Consulting (allgemeine Beratertätigkeit)
          </span>
          <span class="row impressum-subheading bold-font"
            >Berufshaftpflichtversicherung</span
          >
          <span class="row">ERGO Group AG </span>
          <span class="row">Victoriaplatz 2 </span>
          <span class="row">40198 Düsseldorf </span>
          <span class="row">Deutschland </span>
          <span class="row"
            >Räumlicher Geltungsbereich: Weltweit außer USA und Kanada
          </span>
        </div>
      </div>

      <div class="column impressum-info-main" style="padding-left: 10vw">
        <span class="row impressum-subheading bold-font">
          Handelsregister
        </span>
        <span class="row">Registergericht: Amtsgericht Saarbrücken </span>
        <span class="row">Registernummer: HRB 103148 </span>

        <span class="row impressum-subheading bold-font q-mt-md">
          Geschäftsführer
        </span>
        <span class="row">
          Dr. Benjamin Hötzer, Dr. Marc Schaber, Henk Heerink, Jaques Bruins
          Slot
        </span>

        <span class="row impressum-subheading bold-font q-mt-md">
          Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz
        </span>
        <span class="row"> DE 305863860 </span>
        <span class="row impressum-subheading bold-font q-mt-md">
          Inhaltlich Verantwortlicher
        </span>
        <span class="row">Dr. Benjamin Hötzer </span>
        <span class="row">(Anschrift wie oben) </span>
      </div>
    </div>

    <div>
      <div class="impressum-info-main column" style="margin-top: 64px">
        <span class="row impressum-subheading bold-font">
          Informationen zur Online-Streitbeilegung
        </span>
        <span class="row" style="text-align: left"
          >Die Europäische Kommission stellt eine Plattform zur
          Online-Streitbeilegung (OS) bereit. Diese Plattform finden Sie unter
          folgendem Link: &nbsp;
          <a href="https://ec.europa.eu/consumers/odr/" target="_blank">
            https://ec.europa.eu/consumers/odr/. </a
          >Verbraucher können diese Plattform nutzen, um ihre Streitigkeiten aus
          Online-Verträgen beizulegen.
        </span>
      </div>

      <div class="impressum-info-main column" style="margin-top: 24px">
        <span class="row impressum-subheading bold-font">
          Hinweis gemäß § 36 VSBG
        </span>
        <span class="row" style="text-align: left"
          >Wir werden nicht an alternativen Streitschlichtungsverfahren im Sinne
          des § 36 VSBG teilnehmen. Die Nutzung einer alternativen
          Schlichtungsstelle stellt keine zwingende Voraussetzung für das
          Anrufen zuständiger ordentlicher Gerichte dar.
        </span>
      </div>

      <div class="impressum-info-main column" style="margin-top: 24px">
        <span class="row impressum-subheading bold-font">
          Urheberrecht und Bildnachweise
        </span>
        <span class="row" style="text-align: left"
          >Die Inhalte von https://content.deutsches-foerderportal.de sind –
          soweit nicht abweichend angegeben – urheberrechtlich geschützt.
          Verwendete Fotografien sind ggf. mit Bildnachweisen gekennzeichnet
          oder unten aufgeführt, soweit sie nicht selbst angefertigt wurden. Die
          Verwendung von Fotografien auf Drittseiten ist nur im Rahmen der
          jeweiligen Lizenz der Urheber möglich.
        </span>
        <span class="row justify-start">Erstellt durch: </span>
        <span class="row justify-start"
          >© DURY LEGAL Rechtsanwälte – &nbsp;
          <a href="https://www.dury.de" target="_blank"> www.dury.de </a></span
        >
        <span class="row justify-start"
          >© Website-Check GmbH – &nbsp;
          <a href="https://www.website-check.de" target="_blank">
            www.website-check.de
          </a>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ImpressumPage",
  setup() {
    return {};
  },
};
</script>
